"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Clone a map.
 *
 * @param {Map<*, *>} map
 * @returns {Map<*, *>}
 */
function clone(map) {
    let result = new Map();
    for (let [key, value] of map) {
        result.set(key, value);
    }
    return result;
}
exports.clone = clone;
